import { getSummaryReportId } from "Areas/Sidebar/SummaryReports";
import { connect } from "react-redux";
import documentsSidebarMenuActionCreators from "Areas/Sidebar/Documents/redux/actionCreators";
import { getObjects, getObjectsInProgress } from "Areas/Sidebar/Documents/redux/selectors";
import { Permissions, security } from "Common/permissions";
import actionCreators from "./redux/actionCreators";
import { getData, getInProgress } from "./redux/selectors";
import SummaryReportDetails from "./summaryReportDetails";
const canEdit = security.isAllowed([Permissions.SummaryReportsEdit]);
const mapStateToProps = (state) => ({
    summaryReportId: getSummaryReportId(state),
    data: getData(state),
    inProgress: getInProgress(state) || getObjectsInProgress(state),
    documentObjects: getObjects(state),
    canEdit
});
const mapDispatchToProps = (dispatch) => ({
    onInitialized: (summaryReportId) => {
        dispatch(documentsSidebarMenuActionCreators.getObjects());
        dispatch(actionCreators.getSummaryReportDetails(summaryReportId));
    },
    onSave: (data) => dispatch(actionCreators.saveSummaryReportDetails(data)),
    onDestroyed: () => dispatch(actionCreators.clearData())
});
export default connect(mapStateToProps, mapDispatchToProps)(SummaryReportDetails);
